
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const RFMicroneedling = () => {
  const treatmentData = {
    title: "RF Microneedling",
    subtitle: "Radiofrequency microneedling for skin tightening and renewal",
    description: "Combine the benefits of microneedling with radiofrequency energy to stimulate collagen production, tighten skin, and improve texture. The gold standard for non-surgical skin tightening.",
    whoItsFor: [
      "Those with loose or sagging skin",
      "People with acne scars or large pores",
      "Anyone seeking skin tightening",
      "Clients with stretch marks",
      "Those wanting overall skin rejuvenation"
    ],
    packages: [
      {
        name: "RF Microneedling Face",
        visitorPrice: "$650",
        memberPrice: "$585",
        description: "Full face radiofrequency microneedling treatment"
      },
      {
        name: "Face & Neck Package",
        visitorPrice: "$850",
        memberPrice: "$765",
        description: "Comprehensive treatment for face and neck area"
      },
      {
        name: "Series of 3",
        visitorPrice: "$1,750",
        memberPrice: "$1,575",
        description: "Complete package for maximum skin transformation"
      }
    ],
    beforeCare: [
      "Avoid retinoids 3 days prior",
      "No blood thinners for 1 week",
      "Arrive with clean skin",
      "Avoid sun exposure day of treatment"
    ],
    duringCare: [
      "Topical numbing cream applied",
      "Precise microneedling with RF energy",
      "60-90 minute treatment time",
      "Customized depth settings for your skin"
    ],
    afterCare: [
      "Gentle skincare for 24-48 hours",
      "Avoid makeup for 24 hours",
      "Apply healing serum as directed",
      "Results develop over 3-6 months"
    ],
    memberPerks: [
      "10% discount on RF microneedling packages",
      "Complimentary post-treatment recovery kit",
      "Free skin assessment and treatment planning",
      "Priority scheduling for series treatments",
      "Access to professional-grade serums"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default RFMicroneedling;
